/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_By_Track_HelpInputs */



/**
* | output |
* | --- |
* | "Events are split into a new event group for each track in use." |
*
* @param {Segment_By_Track_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_by_track_help = /** @type {((inputs?: Segment_By_Track_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_By_Track_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les événements sont répartis dans un nouveau groupe d'événements pour chaque piste utilisée.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Für jede genutzte Rennstrecke werden die Ereignisse in eine neue Ereignisgruppe aufgeteilt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gli eventi vengono suddivisi in un nuovo gruppo di eventi per ogni pista in uso.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Для каждой используемой трассы события разделяются на отдельную группу.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los eventos se dividen en un nuevo grupo de eventos para cada pista en uso.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每个使用的赛道都会将赛事分成一个新的赛事组。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントは、使用されているトラックごとに新しいイベントグループに分割されます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपयोग में आने वाले प्रत्येक ट्रैक के लिए इवेंट्स को एक नए इवेंट ग्रुप में विभाजित किया जाता है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Os eventos são divididos em um novo grupo de eventos para cada pista em uso.")
	return /** @type {LocalizedString} */ ("Events are split into a new event group for each track in use.")
});